import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MediaQuery from 'react-responsive';
import { determineFilters, extractPSTIdFromURL } from "../../utilities/filters";
import { applyHash as modifyFilters, resetAll, updateDefaultParameters } from "../../actions/filters";
import * as HASH from '../../constants/config/hash';
import * as EVENTS from '../../constants/config/dtm';
import { track } from '../../actions/dtm';
import { applyHash as modifyParts } from "../../actions/parts";
import { applyHash as modifyQS } from "../../actions/quick-search";
import { resetQuickFilters } from "../../actions/filters";
import QuickFilterError from "../QuickFilterError/QuickFilterError";
import { valueUnits } from "../Table2/Filters/Range/Text";
import localization from "../../data/config";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import CustomDropdown from "../CustomDropdown";
import {filtersToHash, userEntryToNumber} from "../../utilities/quick-filters-validations";
import "../QuickFilter/style.css";
import breakpoints from "../../constants/breakpoints";
import { useHistory } from "react-router-dom";

/**
 * @name countSelectedFilters
 * @function
 * @returns {JSX}
 * @description Displays the Total of Filters applied
 */

const countSelectedFilters=(filters) => {
  let count = 0;
    
  for (const filter of Object.values(filters)) {
          if (filter === 'on' || filter) {
      count++;
    }
  }

  return count;
}

/**
 * @name QuickFilter
 * @function
 * @returns {JSX}
 * @description Displays the Quick Filters
 */



const QuickFilter = (props) => {
  
const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);

//#region Common Functions - Functions that have generic behaviour
  const dispatch = useDispatch();
  let isValid;
  const originalDefautlParams = useSelector(
    (state) => state.filters.originalDefautlParams
  );
  const INITIAL_ERROR_STATE ={
    chemHasErrors: false,
    vmaxHasErrors: false,
    ichargeHasErrors: false,
    solarHasErrors: false,
    powerPathHasErrors: false,
    buckHasErrors: false,
    boostHasErrors: false,
    buckBoostHasErrors: false,
    ModuleHasErrors: false,
    monoHasErrors: false,
    syncHasErrors: false,
    vinminHasErrors: false,
    vinmaxHasErrors: false,
    voutHasErrors: false,
    ioutHasErrors: false,
    vout2HasErrors: false,
    iout2HasErrors: false,
    vout3HasErrors: false,
    iout3HasErrors: false,
    numledHasErrors: false,
    numstringHasErrors: false,
    istringHasErrors: false,
    vledminHasErrors: false,
    vledmaxHasErrors: false,
    interfaceHasErrors: false,
    dacTypeHasErrors: false,
    resminHasErrors: false,
    resmaxHasErrors: false,
    chanminHasErrors: false,
    chanmaxHasErrors: false,
    architectureHasErrors: false,
    inputTypeHasErrors: false,
    lowemiHasErrors: false,
    ultrathinHasErrors: false,
    heatsinkHasErrors: false,
    spsmaxHasErrors: false,
    spsminHasErrors:false,
  };

  const [errorArray, setErrorArray] = useState([]);

  const { parameters, ignoredBlanks } = useSelector((state) => ({
    parameters: state.filters.allParameters,
    ignoredBlanks: state.filters.ignoredBlanks,
  }));

  const [resetClicked, setResetClicked] = useState({isReseted: false,});
  const { isReseted } = useSelector((resetClicked) => ({
    isReseted: resetClicked.qs.isReseted,
  }));

 const jsonData = useSelector( (state) => state.filters.quickFilter );

  useEffect(() => {
    if (isReseted){
      setState({
        chem: "",
        vmax: "",
        icharge: "",
        solar: false,
        powerPath: false,
        buck: false,
        boost: false,
        buckBoost: false,
        Module: false,
        mono: false,
        sync: false,
        vinmin: "",
        vinmax: "",
        vout: "",
        iout: "",
        vout2: "",
        iout2: "",
        vout3: "",
        iout3: "",
        numled: "",
        numstring: "",
        istring: "",
        vledmin: "",
        vledmax: "",
        interface: "",
        dacType: "",
        resmin: "",
        resmax: "",
        chanmin: "",
        chanmax: "",
        architecture: "",
        inputType: "",
        lowemi: false,
        ultrathin: false,
        heatsink: false,
        spsmin: "",
        spsmax: "",
      });
      setErrorArray([]);
      setErrorState(INITIAL_ERROR_STATE);
      props.onErrorStateChange([]);
      props.setSelectedFiltersCount(0);
      dispatch(resetQuickFilters(false));
      
    }
  }, [isReseted])

  useEffect(() => {
    modifyFilters(props.mod.modified);
    modifyParts(
      props.mod.compare,
      props.mod.sorted,
      props.mod.filters.reduce((a, b) => Object.assign({}, a, b), {}),
      props.mod.selected,
      ignoredBlanks,
      props.mod.andToggle,
      props.mod.s3Type
    );
    modifyQS(props.mod.qs);
  }, [parameters, props.mod]);

  //useEffect that runs initially and when reset table - this populates the double Ranges values with the default value that comes from the Json
  useEffect(() => {
    if (jsonData && jsonData.quickFilterContainer.quickFilter.filters){
        const filters = jsonData.quickFilterContainer.quickFilter.filters;
        for (const filter of filters) {
          if (filter.type === 'doubleRange') {
            for(const doubleRange of filter.elements){
              let inputs = doubleRange.inputs;
              for(const val of inputs){
                setState((prevState) => ({ ...prevState, [val.input.id]: val.input.value }));
              }
            }
          }
        }
    }
  }, [isReseted])

  const [state, setState] = useState({
    chem: "",
    vmax: "",
    icharge: "",
    solar: false,
    power_path: false,
    buck: false,
    boost: false,
    buckBoost: false,
    Module: false,
    mono: false,
    sync: false,
    vinmin: "",
    vinmax: "",
    vout: "",
    iout: "",
    vout2: "",
    iout2: "",
    vout3: "",
    iout3: "",
    numled: "",
    numstring: "",
    istring: "",
    vledmin: "",
    vledmax: "",
    interface: "",
    dacType: "",
    resmin: "",
    resmax: "",
    chanmin: "",
    chanmax: "",
    architecture: "",
    inputType: "",
    lowemi: false,
    ultrathin: false,
    heatsink: false,
    spsmin:"",
    spsmax:"",
  });

  const [errorState, setErrorState] = useState({INITIAL_ERROR_STATE});
  
  /**
   * @name extractQuickFiltersFromUrl
   * @function
   * @description Uses the URL, search for "qsfv=A|B_C|D", and returns [[A,B],[C,D]]
   */
  const extractQuickFiltersFromUrl = useCallback((url)=> {
    const pattern = /qsfv=([^&]+)/;
    const matches = [];
    const match = url.match(pattern);

    if (match) {
        const valuesString = match[1];
        const pairs = valuesString.split('_');
        //For power_path, we need to have a certain condition, otherwise it will throw an error because it will split "power" and "path|on"
        const powerIndex = pairs.findIndex((pair) => pair === 'power');
        const pathOnIndex = pairs.findIndex((pair) => pair === 'path|on');

        if (powerIndex !== -1 && pathOnIndex !== -1) {
          pairs.splice(powerIndex, 1);
          pairs.splice(pathOnIndex < powerIndex ? pathOnIndex : pathOnIndex - 1, 1);
          pairs.push("power_path|on")
        }

        for (let i = 0; i < pairs.length; i += 1) {
            const valuesArray = [pairs[i].split('|')[0], pairs[i].split('|')[1]];
            matches.push(valuesArray);
        }
    }
    return matches;
  }, []);

   //useEffect to Update the total filters selected when the state changes
  useEffect(() =>{
      /**
     * @name totalSelectedFilters
     * @function
     * @description Update the total filters selected when the state changes
     */

    const totalSelectedFilters = countSelectedFilters(state);
    if(totalSelectedFilters){
      props.setSelectedFiltersCount(totalSelectedFilters)
    }
    
  }, [state])

  //Important useEffect that checks if there are quick filter form values on the URL, and it updates the state
  useEffect(() => {
    let fields = extractQuickFiltersFromUrl(window.location.href);
    props.setSelectedFiltersCount(fields.length)
    //fields will return this: [[filterName1, value1],[filterName2,value2]]
    for (const filter in fields) {
      const field = fields[filter][0];
      const value = fields[filter][1].replace(/%20/g, ' ');
      setState((prevState) => ({ ...prevState, [field]: value }))
    }
  }, [props.parameter, extractQuickFiltersFromUrl]);

  const getQsFormValues = (selectedFilters) => {
    const formValues = [];

    for (const key in selectedFilters) {
      const value = selectedFilters[key];
      if (value !== null && value !== undefined && value !== "") {
        formValues.push(`${key}|${encodeURIComponent(value)}`);
      }
    }

    return formValues.join("_");
  };

  const history = useHistory();

  const handleSearch = (event) => {
    if(event){
      event.preventDefault()
    };
  
    const selectedFilters = {
      chem: state.chem,
      vmax: state.vmax,
      icharge: state.icharge,
      solar: state.solar ? "on" : "",
      power_path: state.power_path ? "on" : "",
      buck: state.buck ? "on" : "",
      boost: state.boost ? "on" : "",
      buckBoost: state.buckBoost ? "on" : "",
      Module: state.Module ? "on" : "",
      mono: state.mono ? "on" : "",
      sync: state.sync ? "on" : "",
      vinmin: state.vinmin,
      vinmax: state.vinmax,
      vout: state.vout,
      iout: state.iout,
      vout2: state.vout2,
      iout2: state.iout2,
      vout3: state.vout3,
      iout3: state.iout3,
      numled: state.numled,
      numstring: state.numstring,
      istring: state.istring,
      vledmin: state.vledmin,
      vledmax: state.vledmax,
      interface: state.interface,
      dacType: state.dacType,
      resmin: state.resmin,
      resmax: state.resmax,
      chanmin: state.chanmin,
      chanmax: state.chanmax,
      architecture: state.architecture,
      inputType: state.inputType,
      lowemi: state.lowemi ? "on" : "",
      ultrathin: state.ultrathin ? "on" : "",
      heatsink: state.heatsink ? "on" : "",
      spsmin: state.spsmin,
      spsmax: state.spsmax,
    };
    //Applying any filter and then removing the filter has to reset the table
    //Checking if when the user clicks on search, if there are any filters selected or not
    let isQFSelected = false;
    for (const filter of Object.values(selectedFilters)) {
      if (filter === "on" || filter !== "") {
          isQFSelected = true;
      }
    }

  if(!isQFSelected){
      dispatch(resetAll());
  }
  function getCheckedLabels(section) {
    const checkedLabels = [];
    section.forEach(checkbox => {
        let getCheckboxId = document.getElementById(checkbox.id);
        if (getCheckboxId.checked && checkbox.id) {
            checkedLabels.push(checkbox.label);
        }
    });
    return checkedLabels;
  }

    let interactionInfo;
    jsonData.quickFilterContainer.quickFilter.filters.forEach(filter => {
      
      filter.elements.forEach(element => {
        let category = filter.category;
        let label = element.label;
        if(filter.type === "range" || filter.type === "input" || filter.type === "dropdown"){
          
          let objectLabel = category ? `${category}-${label}` : label;
          if(selectedFilters[element.id]){
            interactionInfo = {...interactionInfo , [objectLabel]: selectedFilters[element.id]}
          }
        }
        if(filter.type === "doubleRange"){
          let doubleRangeOutput = `${selectedFilters[element.inputs[0].input.id]} to ${selectedFilters[element.inputs[1].input.id]}`;
          let objectLabel = `${category}-${label}`;
          if(selectedFilters[element.inputs[0].input.id] && selectedFilters[element.inputs[1].input.id]){
            
            interactionInfo = {...interactionInfo , [objectLabel]: doubleRangeOutput}
          }
        }
        if(filter.type === "checkbox"){
          let checkboxOutput = getCheckedLabels(filter.elements);
          interactionInfo = {...interactionInfo , [category]: checkboxOutput.join('|')}
        }
      })
    })
            

      window.adobeDataLayer.push({
        event: 'PST Table Interaction',
        pstInteractionsInfo: interactionInfo,
      });
  
    setErrorArray([]);
    setErrorState(INITIAL_ERROR_STATE);
    props.onErrorStateChange([]);
    isValid = validateForm(selectedFilters, jsonData);
    props.setSelectedFiltersCount(countSelectedFilters(selectedFilters));
    
    if (!isValid){
    
      const qsValues = "";
      const filterHash = "";

      // Construct the full hash fragment including qsfv
      const hashFragment = qsValues
        ? `${filterHash}&qsfv=${qsValues}`
        : filterHash;
  
      const newUrl = `${window.location.pathname}#/${hashFragment}`;
  
      history.push(newUrl);

    }
  };

  const handleSearchMobile = () => {
    handleSearch();
    if(!isValid){
      props.closeModal();
    }
  }

  const handleCancel = () => {
    setErrorArray([]);
    setErrorState(INITIAL_ERROR_STATE);
    props.onErrorStateChange([]);
    dispatch(resetQuickFilters(true));
    props.setSelectedFiltersCount(0)
  }; 
  
  const handleInputChange = (event, tempValue) => {
    const { name, value, type, checked, labelId } = event.target;

    let inputValue = type === "checkbox" ? checked : value;
    let tempName = name;

    if(tempValue != null){
      inputValue = tempValue;
    }

    if(name == null | name == ""){
      tempName = event.currentTarget.getAttribute("name");

    }
    setState((prevState) => ({ ...prevState, [tempName]: inputValue }));
  };

  const checkFieldErrors = (key) =>{
    let errorClass = errorState[`${key}HasErrors`] ? "classError" : "";

    return errorClass;
  };

//#endregion

//#region Business Function - Function that has specific behaviour for each one of the quick filters type and updates the error state
  const validateForm = (selectedFilters) => {
    var com = window._qfCommon;
    let tempErrorArray = new Array();
    let iout2 = document.getElementById('iout2');
    let vout2 = document.getElementById('vout2');
    let iout3 = document.getElementById('iout3');
    let vout3 = document.getElementById('vout3');

    switch (jsonData.quickFilterType) {
      case "bat":
        let vmaxMinBat = 5.5,
            vmaxMaxBat = 60,
            ichargeMinBat = 0.475,
            ichargeMaxBat = 40;

        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
            value = userEntryToNumber( value );
            if (key === "vmax"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vmax').getAttribute('data-label'), "n^",vmaxMinBat, vmaxMinBat);
              com.chkQsErr(tempErrorArray, value, document.getElementById('vmax').getAttribute('data-label'), "nv",vmaxMaxBat, vmaxMaxBat);
            }
            if(key === "icharge"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('icharge').getAttribute('data-label'), "n^",ichargeMinBat, ichargeMinBat); 
              com.chkQsErr(tempErrorArray, value,document.getElementById('icharge').getAttribute('data-label'), "nv",ichargeMaxBat, ichargeMaxBat); 
            }  
          }
        }
        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('icharge').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ichargeHasErrors: true }))
          }
        })
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
        
        return ( tempErrorArray.length > 0 );

      case "batch":
        let vmaxMinBatch = 4.9,
        vmaxMaxBatch = 60,
        ichargeMinBatch = 0.025,
        ichargeMaxBatch = 40;

        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "vmax"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vmax').getAttribute('data-label'), "n^",vmaxMinBatch, vmaxMinBatch);
              com.chkQsErr(tempErrorArray, value, document.getElementById('vmax').getAttribute('data-label'), "nv",vmaxMaxBatch, vmaxMaxBatch);
            
              }
              if(key === "icharge"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('icharge').getAttribute('data-label'), "n^",ichargeMinBatch, ichargeMinBatch); 
              com.chkQsErr(tempErrorArray, value,document.getElementById('icharge').getAttribute('data-label'), "nv",ichargeMaxBatch, ichargeMaxBatch); 
              }
          }
        }
    
        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('icharge').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ichargeHasErrors: true }))
          }
        })
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
        
        return ( tempErrorArray.length > 0 );

      case "LDO":
        com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vout"], document.getElementById('vout').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["iout"], document.getElementById('iout').getAttribute('data-label'), "r");

        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "vinmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "n");
              }
              if(key === "vinmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
              }
              if (key === "vout"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vout').getAttribute('data-label'), "n");
              }
              if(key === "iout"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('iout').getAttribute('data-label'), "p"); 
              }
          }
        }

        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
          }
          if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('vout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, voutHasErrors: true }))
          }
          if(item.includes(document.getElementById('iout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ioutHasErrors: true }))
          }
        })

        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
        
        return ( tempErrorArray.length > 0 );
      
      case "LED":
      //First checking if required fields are submitted
      com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["numled"], document.getElementById('numled').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["numstring"], document.getElementById('numstring').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["istring"], document.getElementById('istring').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["vledmin"], document.getElementById('vledmin').getAttribute('data-label'), "r");
      com.chkQsErr(tempErrorArray, selectedFilters["vledmax"], document.getElementById('vledmax').getAttribute('data-label'), "r");

      for (const key in selectedFilters) {
        let value = selectedFilters[key];
        if (value !== null && value !== undefined && value !== "") {
            value = userEntryToNumber( value );
            if (key === "vinmin"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "p>");
            }
            if(key === "vinmax"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
            }
            if (key === "numled"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('numled').getAttribute('data-label'), "p");
            }
            if(key === "numstring"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('numstring').getAttribute('data-label'), "p"); 
            }
            if(key === "istring"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('istring').getAttribute('data-label'), "p"); 
            }
            if(key === "vledmin"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vledmin').getAttribute('data-label'), "p"); 
            }
            if(key === "vledmax"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vledmax').getAttribute('data-label'), "p>"); 
            }
        }
      }

      tempErrorArray.forEach(function(item){
        if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
        }
        if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
        }
        if(item.includes(document.getElementById('numled').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, numledHasErrors: true }))
        }
        if(item.includes(document.getElementById('numstring').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, numstringHasErrors: true }))
        }
        if(item.includes(document.getElementById('istring').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, istringHasErrors: true }))
        }
        if(item.includes(document.getElementById('vledmin').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, vledminHasErrors: true }))
        }
        if(item.includes(document.getElementById('vledmax').getAttribute('data-label'))){
          setErrorState((prevState) => ({ ...prevState, vledmaxHasErrors: true }))
        }
      })

      setErrorArray(tempErrorArray);
      props.onErrorStateChange(tempErrorArray);
      
      return ( tempErrorArray.length > 0 );
    
      case "pdac":
        // min/max values
      let resMinPDAC = 6,
      resMaxPDAC = 20,
      chanMinPDAC = 1,
      chanMaxPDAC = 40;

      //If no value is set by user, uses the default values -> legacy behavior
      if (selectedFilters["resmin"] == "") {
        selectedFilters["resmin"] = resMinPDAC.toString(); 
        setState((prevState) => ({ ...prevState, ["resmin"]: resMinPDAC }))
      }
      if (selectedFilters["resmax"] == "") {
        selectedFilters["resmax"] = resMaxPDAC.toString(); 
        setState((prevState) => ({ ...prevState, ["resmax"]: resMaxPDAC }))
      }
      if (selectedFilters["chanmin"] == "") {
        selectedFilters["chanmin"] = chanMinPDAC.toString(); 
        setState((prevState) => ({ ...prevState, ["chanmin"]: chanMinPDAC }))
      }
      if (selectedFilters["chanmax"] == "") {
        selectedFilters["chanmax"] = chanMaxPDAC.toString();
        setState((prevState) => ({ ...prevState, ["chanmax"]: chanMaxPDAC }))
      }
    
      for (const key in selectedFilters) {
        let value = selectedFilters[key];
        if (value !== null && value !== undefined && value !== "") {
          value = userEntryToNumber( value );
          if (key === "resmin"){
            com.chkQsErr(tempErrorArray, value, document.getElementById('resLabel').getAttribute('data-label') + ": Min", "n^", resMinPDAC, resMinPDAC);
          }
          if(key === "resmax"){
            com.chkQsErr(tempErrorArray, value,document.getElementById('resLabel').getAttribute('data-label') + ": Max", "nv", resMaxPDAC, resMaxPDAC); 
          }
          if (key === "chanmin"){
            com.chkQsErr(tempErrorArray, value, document.getElementById('chanLabel').getAttribute('data-label') + ": Min", "n^", chanMinPDAC, chanMinPDAC);
          }
          if(key === "chanmax"){
            com.chkQsErr(tempErrorArray, value,document.getElementById('chanLabel').getAttribute('data-label') + ": Max", "nv", chanMaxPDAC, chanMaxPDAC); 
          }
        }
      }

      tempErrorArray.forEach(function(item){
        if(item.includes(document.getElementById('resLabel').getAttribute('data-label')+ ": Min")){
          setErrorState((prevState) => ({ ...prevState, resminHasErrors: true }))
        }
        if(item.includes(document.getElementById('resLabel').getAttribute('data-label')+ ": Max")){
          setErrorState((prevState) => ({ ...prevState, resmaxHasErrors: true }))
        }
        if(item.includes(document.getElementById('chanLabel').getAttribute('data-label') + ": Min")){
          setErrorState((prevState) => ({ ...prevState, chanminHasErrors: true }))
        }
        if(item.includes(document.getElementById('chanLabel').getAttribute('data-label') + ": Max")){
          setErrorState((prevState) => ({ ...prevState, chanmaxHasErrors: true }))
        }
      })
      setErrorArray(tempErrorArray);
      props.onErrorStateChange(tempErrorArray);

      return ( tempErrorArray.length > 0 );
      
      case "precision":
        // min/max values
        let resMinPrecision = 8,
        resMaxPrecision = 32,
        chanMinPrecision = 1,
        chanMaxPrecision = 16,
        spsMinPrecision = 6.8,
        spsMaxPrecision = 20000000;

        //Default value if no other value is inserted
        if (selectedFilters["resmin"] == "") {
          selectedFilters["resmin"] = resMinPrecision.toString();
          setState((prevState) => ({ ...prevState, ["resmin"]: resMinPrecision }))
        }
        if (selectedFilters["resmax"] == "") {
          selectedFilters["resmax"] = resMaxPrecision.toString();
          setState((prevState) => ({ ...prevState, ["resmax"]: resMaxPrecision }))
        }
        if (selectedFilters["chanmin"] == "") {
          selectedFilters["chanmin"] = chanMinPrecision.toString();
          setState((prevState) => ({ ...prevState, ["chanmin"]: chanMinPrecision }))
        }
        if (selectedFilters["chanmax"] == "") {
          selectedFilters["chanmax"] = chanMaxPrecision.toString();
          setState((prevState) => ({ ...prevState, ["chanmax"]: chanMaxPrecision }))
        }
        if (selectedFilters["spsmin"] == "") {
          selectedFilters["spsmin"] = spsMinPrecision.toString();
          setState((prevState) => ({ ...prevState, ["spsmin"]: spsMinPrecision }))
        }
        if (selectedFilters["spsmax"] == "") {
          selectedFilters["spsmax"] = spsMaxPrecision.toString();
          setState((prevState) => ({ ...prevState, ["spsmax"]: spsMaxPrecision }))
        }

        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "resmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('resLabel').getAttribute('data-label') + ": Min", "n^", resMinPrecision, resMinPrecision);
              }
              if(key === "resmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('resLabel').getAttribute('data-label') + ": Max", "nv", resMaxPrecision, resMaxPrecision); 
              }
              if (key === "chanmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('chanLabel').getAttribute('data-label') + ": Min", "n^", chanMinPrecision, chanMinPrecision);
              }
              if(key === "chanmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('chanLabel').getAttribute('data-label') + ": Max", "nv", chanMaxPrecision, chanMaxPrecision); 
              }
              if(key === "spsmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('spsLabel').getAttribute('data-label') + ": Min", "n^", spsMinPrecision, spsMinPrecision); 
              }
              if(key === "spsmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('spsLabel').getAttribute('data-label') + ": Max", "nv", spsMaxPrecision, spsMaxPrecision); 
              }
          }
        }

        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('resLabel').getAttribute('data-label')+ ": Min")){
            setErrorState((prevState) => ({ ...prevState, resminHasErrors: true }))
          }
          if(item.includes(document.getElementById('resLabel').getAttribute('data-label')+ ": Max")){
            setErrorState((prevState) => ({ ...prevState, resmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('chanLabel').getAttribute('data-label') + ": Min")){
            setErrorState((prevState) => ({ ...prevState, chanminHasErrors: true }))
          }
          if(item.includes(document.getElementById('chanLabel').getAttribute('data-label') + ": Max")){
            setErrorState((prevState) => ({ ...prevState, chanmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('spsLabel').getAttribute('data-label') + ": Min")){
            setErrorState((prevState) => ({ ...prevState, spsminHasErrors: true }))
          }
          if(item.includes(document.getElementById('spsLabel').getAttribute('data-label') + ": Max")){
            setErrorState((prevState) => ({ ...prevState, spsmaxHasErrors: true }))
          }
        })

        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
          
        return ( tempErrorArray.length > 0 );
      
      case "swreg":
        com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vout"], document.getElementById('vout').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["iout"], document.getElementById('iout').getAttribute('data-label'), "r");
        
        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "vinmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "n");
              }
              if(key === "vinmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
              }
              if (key === "vout"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vout').getAttribute('data-label'), "n");
              }
              if(key === "iout"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('iout').getAttribute('data-label'), "np"); 
              }
          }
        }

        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
          }
          if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('vout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, voutHasErrors: true }))
          }
          if(item.includes(document.getElementById('iout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ioutHasErrors: true }))
          }
        })
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
            
        return ( tempErrorArray.length > 0 );
            
      case "swreg2":
        com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vout"], document.getElementById('vout').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["iout"], document.getElementById('iout').getAttribute('data-label'), "r");
        
        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "vinmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "n");
              }
              if(key === "vinmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
              }
              if(key === "vout"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('vout').getAttribute('data-label'), "n"); 
              }
              if(key === "iout"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('iout').getAttribute('data-label'), "p"); 
              }
              if(key === "vout2"){
                com.chkQsErr(tempErrorArray, value,vout2.getAttribute('data-label'), "n"); 
              }
              if(key === "iout2"){
                com.chkQsErr(tempErrorArray, value,iout2.getAttribute('data-label'), "p"); 
              }
          }
        }
    
        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
          }
          if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('vout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, voutHasErrors: true }))
          }
          if(item.includes(document.getElementById('iout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ioutHasErrors: true }))
          }
          if(vout2 && item.includes(vout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vout2HasErrors: true }))
          }
          if(iout2 && item.includes(iout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, iout2HasErrors: true }))
          }
        })
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
              
        return ( tempErrorArray.length > 0 );
              
      case "swregbig":
        com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vout"], document.getElementById('vout').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["iout"], document.getElementById('iout').getAttribute('data-label'), "r");
        
        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
            value = userEntryToNumber( value );
            if (key === "vinmin"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "n");
            }
            if(key === "vinmax"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
            }
            if (key === "vout"){
              com.chkQsErr(tempErrorArray, value, document.getElementById('vout').getAttribute('data-label'), "n");
            }
            if(key === "iout"){
              com.chkQsErr(tempErrorArray, value,document.getElementById('iout').getAttribute('data-label'), "p"); 
            }
            if (key === "vout2"){
              com.chkQsErr(tempErrorArray, value, vout2.getAttribute('data-label'), "n");
            }
            if(key === "iout2"){
              com.chkQsErr(tempErrorArray, value,iout2.getAttribute('data-label'), "p"); 
            }
            if (key === "vout3"){
              com.chkQsErr(tempErrorArray, value, vout3.getAttribute('data-label'), "n");
            }
            if(key === "iout3"){
              com.chkQsErr(tempErrorArray, value,iout3.getAttribute('data-label'), "p"); 
            }
          }
        }
    
        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
          }
          if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('vout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, voutHasErrors: true }))
          }
          if(item.includes(document.getElementById('iout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ioutHasErrors: true }))
          }
          if(vout2 && item.includes(vout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vout2HasErrors: true }))
          }
          if(iout2 && item.includes(iout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, iout2HasErrors: true }))
          }
          if(vout3 && item.includes(vout3.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vout3HasErrors: true }))
          }
          if(iout3 && item.includes(iout3.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, iout3HasErrors: true }))
          }
        })
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
                
        return ( tempErrorArray.length > 0 );
                
      case "umodregbig":
        com.chkQsErr(tempErrorArray, selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vinmax"], document.getElementById('vinmax').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["vout"], document.getElementById('vout').getAttribute('data-label'), "r");
        com.chkQsErr(tempErrorArray, selectedFilters["iout"], document.getElementById('iout').getAttribute('data-label'), "r");
    
        for (const key in selectedFilters) {
          let value = selectedFilters[key];
          if (value !== null && value !== undefined && value !== "") {
              value = userEntryToNumber( value );
              if (key === "vinmin"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vinmin').getAttribute('data-label'), "n");
              }
              if(key === "vinmax"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('vinmax').getAttribute('data-label'), "n^", selectedFilters["vinmin"], document.getElementById('vinmin').getAttribute('data-label')); 
              }
              if (key === "vout"){
                com.chkQsErr(tempErrorArray, value, document.getElementById('vout').getAttribute('data-label'), "n");
              }
              if(key === "iout"){
                com.chkQsErr(tempErrorArray, value,document.getElementById('iout').getAttribute('data-label'), "p"); 
              }
              if (key === "vout2"){
                com.chkQsErr(tempErrorArray, value, vout2.getAttribute('data-label'), "n");
              }
              if(key === "iout2"){
                com.chkQsErr(tempErrorArray, value,iout2.getAttribute('data-label'), "p"); 
              }
              if (key === "vout3"){
                com.chkQsErr(tempErrorArray, value, vout3.getAttribute('data-label'), "n");
              }
              if(key === "iout3"){
                com.chkQsErr(tempErrorArray, value,iout3.getAttribute('data-label'), "p"); 
              }
          }
        }
    
        tempErrorArray.forEach(function(item){
          if(item.includes(document.getElementById('vinmin').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinminHasErrors: true }))
          }
          if(item.includes(document.getElementById('vinmax').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vinmaxHasErrors: true }))
          }
          if(item.includes(document.getElementById('vout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, voutHasErrors: true }))
          }
          if(item.includes(document.getElementById('iout').getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, ioutHasErrors: true }))
          }
          if(vout2 && item.includes(vout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vout2HasErrors: true }))
          }
          if(iout2 && item.includes(iout2.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, iout2HasErrors: true }))
          }
          if(vout3 && item.includes(vout3.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, vout3HasErrors: true }))
          }
          if(iout3 && item.includes(iout3.getAttribute('data-label'))){
            setErrorState((prevState) => ({ ...prevState, iout3HasErrors: true }))
          }
        })
    
        setErrorArray(tempErrorArray);
        props.onErrorStateChange(tempErrorArray);
                  
        return ( tempErrorArray.length > 0 );
                                
      default: //Unknown validation option, exit.
      return;
      }
  };

/**
* @name handleButtonAdditionalFilters
* @function
* @returns {void}
* @description This function is responsible for toggling the visibility of additional filters.
* It updates the state of `showAdditionalFilters`.
*/

  const handleButtonAdditionalFilters = () => {
    setShowAdditionalFilters(!showAdditionalFilters);
  };

//#endregion

const hasQuickLinks = useMemo( () => jsonData.quickFilterContainer.quickFilter.filters.some(
  category => category.type === "quickLinks" && category.elements.length > 0
), [ jsonData ]);

  return (
    <div className={jsonData.quickFilterType} id="quickFilterContainer">
      <MediaQuery minDeviceWidth={breakpoints.tablet.min}>
        <div className="quickfilter-wrapper">
          <div className="quick-filter-title">
            {jsonData.quickFilterContainer.quickFilterTitle}
          </div>
          <div className="quickfilter-container">
            {jsonData.quickFilterContainer.quickFilter.filters.map(
              (category, index) => (
                <div key={index} className="quickfilter-row">
                  <div className="quickfilter-col-16 category-title">
                    {category.type !== "quickLinks" && category.category}
                  </div>
                  {category.elements.map((element, subIndex) => (
                    <div
                      key={subIndex}
                      className="quickfilter-col-16 filter-element"
                    >
                      {category.type === "dropdown" && (
                        <div className="quickfilter-type-dropdown">
                          <label htmlFor={element.id}>{element.label}</label>
                          <CustomDropdown
                            options={element.options}
                            name={element.name}
                            id={element.id}
                            datafilterid={element.dataFilterId}
                            selectedValue={state[element.name]}
                            label={element.label}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}
                      {category.type === "range" && (
                        <div className="quickfilter-type-range">
                          <label
                            data-label={element.label}
                            id={element.id}
                            htmlFor={element.id}
                            dangerouslySetInnerHTML={{ __html: element.label }}
                          ></label>
                          <div className="quickfilter-type-range-input">
                            <input
                              className={checkFieldErrors(element.name)}
                              name={element.name}
                              id={element.id}
                              value={state[element.name]}
                              type="text"
                              data-filter-id={element.dataFilterId}
                              data-value={element.values}
                              size={element.size}
                              onChange={handleInputChange}
                              aria-label={`${element.label} ${valueUnits(
                                element.unit
                              )}`}
                              role="textbox"
                            />
                            <span>{element.unit}</span>
                          </div>
                        </div>
                      )}
                      {category.type === "doubleRange" && (
                        <div className="field doubleRange-field">
                          <label
                            data-label={element.label}
                            id={element.labelId}
                            className="row-title"
                          >
                            {element.label}
                          </label>
                          <div className="doubleRange-component">
                            {element.inputs.map((e, index) => (
                              <div key={index} className="text-values">
                                <label
                                  dangerouslySetInnerHTML={{ __html: e.label }}
                                ></label>
                                <input
                                  className={checkFieldErrors(e.input.name)}
                                  id={e.input.id}
                                  name={e.input.name}
                                  type={e.input.type}
                                  data-type={e.input.dataType}
                                  data-filter-id={element.dataFilterId}
                                  value={state[e.input.name]}
                                  onChange={handleInputChange}
                                  aria-label={element.label}
                                  role="textbox"
                                ></input>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {category.type === "checkbox" && (
                        <div className="quickfilter-type-checkbox">
                          <CustomCheckbox
                            label={`${
                              element.labelMicro ? element.labelMicro : ""
                            }${element.label}`}
                            customClass={checkFieldErrors(element.name)}
                            type="checkbox"
                            id={element.id}
                            name={element.name}
                            datafilterid={element.dataFilterId}
                            datasvalue={element.values}
                            checked={state[element.name]}
                            onChange={handleInputChange}
                            tabIndex={0}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )
            )}
            {jsonData.quickFilterContainer.quickFilter.additionalFilters && (
              <div className="quickfilter-row">
                <div className="quickfilter-col-16 category-title"></div>
                <div className="quickfilter-col-16 filter-element">
                  <button
                    className="primary_btn"
                    onClick={handleButtonAdditionalFilters}
                  >
                    {localization.multipleOutputs}
                  </button>
                </div>
              </div>
            )}
            {showAdditionalFilters &&
              jsonData.quickFilterContainer.quickFilter.additionalFilters &&
              jsonData.quickFilterContainer.quickFilter.addFilters.map(
                (additionQF, index) => (
                  <div key={index} className="quickfilter-row">
                    <div className="quickfilter-col-16 category-title">
                      {additionQF.category}
                    </div>
                    {additionQF.elements.map((element, subIndex) => (
                      <div
                        key={subIndex}
                        className="quickfilter-col-16 filter-element"
                      >
                        {additionQF.type === "dropdown" && (
                          <div className="quickfilter-type-dropdown">
                            <label htmlFor={element.id}>{element.label}</label>
                            <CustomDropdown
                              options={element.options}
                              name={element.name}
                              id={element.id}
                              datafilterid={element.dataFilterId}
                              selectedValue={state[element.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                        {additionQF.type === "range" && (
                          <div className="quickfilter-type-range">
                            <label
                              data-label={element.label}
                              id={element.id}
                              htmlFor={element.id}
                              dangerouslySetInnerHTML={{
                                __html: element.label,
                              }}
                            ></label>
                            <div className="quickfilter-type-range-input">
                              <input
                                className={checkFieldErrors(element.name)}
                                name={element.name}
                                id={element.id}
                                value={state[element.name]}
                                type="text"
                                data-filter-id={element.dataFilterId}
                                data-value={element.values}
                                size={element.size}
                                onChange={handleInputChange}
                                aria-label={element.label}
                                role="textbox"
                              />
                              <span>{element.unit}</span>
                            </div>
                          </div>
                        )}
                        {additionQF.type === "checkbox" && (
                          <div className="quickfilter-type-checkbox">
                            <CustomCheckbox
                              label={`${
                                element.labelMicro ? element.labelMicro : ""
                              }${element.label}`}
                              customClass={checkFieldErrors(element.name)}
                              type="checkbox"
                              id={element.id}
                              name={element.name}
                              datafilterid={element.dataFilterId}
                              datasvalue={element.values}
                              checked={state[element.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
              )}
          </div>
          {jsonData.quickFilterContainer.quickFilter.legend != null && (
            <div className="quickfilter-row quickfilter-legend">
              <div className="quickfilter-col-16 quickfilter-legend-first-col"></div>
              <div className="quickfilter-col-16 quickfilter-legend-second-col">
                <p className="legend">
                  {" "}
                  {jsonData.quickFilterContainer.quickFilter.legend}{" "}
                </p>
              </div>
            </div>
          )}
          <hr className="break-line" aria-hidden="true"></hr>
          <div className="quickfilter-row">
            <div className="quickfilter-col-16-button">
              <div className="quickfilter-row-button">
                <div className="quickfilter-col-button search-button">
                  <button
                    type="button"
                    onClick={handleSearch}
                    id={localization.searchButtonLabel}
                    className="quick-filter-search primary_btn"
                  >
                    {localization.searchButtonLabel}
                  </button>
                </div>
                <div className="quickfilter-col-button cancel-button">
                  <button
                    type="button"
                    onClick={() => {
                      props.setToggle();
                      handleCancel();
                    }}
                    className="quick-filter-cancel secondary_btn"
                  >
                    {localization.cancel}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {hasQuickLinks && (
          <div className="quickfilter-wrapper quicklinks-wrapper">
            <div className="quickfilter-container">
              {jsonData.quickFilterContainer.quickFilter.filters.map(
                (category, index) => (
                  <div key={index} className="quickfilter-row">
                    <div className="quickfilter-col-16 category-title">
                      {category.description}
                    </div>
                    {category.elements.map((element, subIndex) => (
                      <div
                        key={subIndex}
                        className="quickfilter-col-16 filter-element"
                      >
                        {category.type === "quickLinks" && (
                          <div className="quicklinks-component fields links">
                            <a
                              className="quickfilter-col-16 filter-element"
                              href={element.href}
                            >
                              {element.linkTitle}
                            </a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        )}
      </MediaQuery>
      <MediaQuery maxDeviceWidth={breakpoints.mobile.max}>
        <div className="quickfilter-wrapper-mbl">
          <div className="quick-filter-title">
            {jsonData.quickFilterContainer.quickFilterTitle}
          </div>
          <div className="quickfilter-container-mbl">
            {jsonData.quickFilterContainer.quickFilter.filters.map(
              (category, index) => (
                <div key={index} className="quickfilter-row-mbl">
                  <div className="quickfilter-col-16-mbl category-title">
                    {category.type !== "quickLinks" && category.category}
                  </div>
                  {category.elements.map((element, subIndex) => (
                    <div
                      key={subIndex}
                      className="quickfilter-col-16-mbl filter-element"
                    >
                      {category.type === "dropdown" && (
                        <div className="quickfilter-type-dropdown">
                          <label htmlFor={element.id}>{element.label}</label>
                          <CustomDropdown
                            options={element.options}
                            name={element.name}
                            id={element.id}
                            datafilterid={element.dataFilterId}
                            selectedValue={state[element.name]}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}
                      {category.type === "range" && (
                        <div className="quickfilter-type-range">
                          <label
                            data-label={element.label}
                            id={element.id}
                            htmlFor={element.id}
                            dangerouslySetInnerHTML={{ __html: element.label }}
                          ></label>
                          <div className="quickfilter-type-range-input">
                            <input
                              className={checkFieldErrors(element.name)}
                              name={element.name}
                              id={element.id}
                              value={state[element.name]}
                              type="text"
                              data-filter-id={element.dataFilterId}
                              data-value={element.values}
                              size={element.size}
                              onChange={handleInputChange}
                              aria-label={element.label}
                              role="textbox"
                            />
                            <span>{element.unit}</span>
                          </div>
                        </div>
                      )}
                      {category.type === "doubleRange" && (
                        <div className="field doubleRange-field">
                          <label
                            data-label={element.label}
                            id={element.labelId}
                            className="row-title"
                          >
                            {element.label}
                          </label>
                          <div className="doubleRange-component">
                            {element.inputs.map((e, index) => (
                              <div key={index} className="text-values">
                                <label
                                  dangerouslySetInnerHTML={{ __html: e.label }}
                                ></label>
                                <input
                                  className={checkFieldErrors(e.input.name)}
                                  id={e.input.id}
                                  name={e.input.name}
                                  type={e.input.type}
                                  data-type={e.input.dataType}
                                  data-filter-id={element.dataFilterId}
                                  value={state[e.input.name]}
                                  onChange={handleInputChange}
                                  aria-label={element.label}
                                  role="textbox"
                                ></input>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {category.type === "checkbox" && (
                        <div className="quickfilter-type-checkbox">
                          <CustomCheckbox
                            label={`${
                              element.labelMicro ? element.labelMicro : ""
                            }${element.label}`}
                            customClass={checkFieldErrors(element.name)}
                            type="checkbox"
                            id={element.id}
                            name={element.name}
                            datafilterid={element.dataFilterId}
                            datasvalue={element.values}
                            checked={state[element.name]}
                            onChange={handleInputChange}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )
            )}
            {jsonData.quickFilterContainer.quickFilter.additionalFilters &&
              jsonData.quickFilterContainer.quickFilter.addFilters.map(
                (additionQF, index) => (
                  <div key={index} className="quickfilter-row-mbl">
                    <div className="quickfilter-col-16-mbl category-title">
                      {additionQF.category}
                    </div>
                    {additionQF.elements.map((element, subIndex) => (
                      <div
                        key={subIndex}
                        className="quickfilter-col-16-mbl filter-element"
                      >
                        {additionQF.type === "dropdown" && (
                          <div className="quickfilter-type-dropdown">
                            <label htmlFor={element.id}>{element.label}</label>
                            <CustomDropdown
                              options={element.options}
                              name={element.name}
                              id={element.id}
                              datafilterid={element.dataFilterId}
                              selectedValue={state[element.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                        {additionQF.type === "range" && (
                          <div className="quickfilter-type-range">
                            <label
                              data-label={element.label}
                              id={element.id}
                              htmlFor={element.id}
                              dangerouslySetInnerHTML={{
                                __html: element.label,
                              }}
                            ></label>
                            <div className="quickfilter-type-range-input">
                              <input
                                className={checkFieldErrors(element.name)}
                                name={element.name}
                                id={element.id}
                                value={state[element.name]}
                                type="text"
                                data-filter-id={element.dataFilterId}
                                data-value={element.values}
                                size={element.size}
                                onChange={handleInputChange}
                                aria-label={element.label}
                                role="textbox"
                              />
                              <span>{element.unit}</span>
                            </div>
                          </div>
                        )}
                        {additionQF.type === "checkbox" && (
                          <div className="quickfilter-type-checkbox">
                            <CustomCheckbox
                              label={`${
                                element.labelMicro ? element.labelMicro : ""
                              }${element.label}`}
                              customClass={checkFieldErrors(element.name)}
                              type="checkbox"
                              id={element.id}
                              name={element.name}
                              datafilterid={element.dataFilterId}
                              datasvalue={element.values}
                              checked={state[element.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
              )}
          </div>
          {jsonData.quickFilterContainer.quickFilter.legend != null && (
            <div className="quickfilter-row-mbl quickfilter-legend">
              <div className="quickfilter-col-16-mbl quickfilter-legend-first-col-mbl"></div>
              <div className="quickfilter-col-16-mbl quickfilter-legend-second-col-mbl">
                <p className="legend">
                  {" "}
                  {jsonData.quickFilterContainer.quickFilter.legend}{" "}
                </p>
              </div>
            </div>
          )}
          <hr className="break-line-mbl" aria-hidden="true"></hr>
          <div className="quickfilter-wrapper-mbl quicklinks-wrapper">
            <div className="quickfilter-container-mbl">
              {jsonData.quickFilterContainer.quickFilter.filters.map(
                (category, index) => (
                  <div key={index} className="quickfilter-row-mbl">
                    <div className="quickfilter-col-16-mbl category-title">
                      {category.description}
                    </div>
                    {category.elements.map((element, subIndex) => (
                      <div
                        key={subIndex}
                        className="quickfilter-col-16-mbl filter-element"
                      >
                        {category.type === "quickLinks" && (
                          <div className="quicklinks-component fields links">
                            <a
                              className="quickfilter-col-16-mbl filter-element"
                              href={element.href}
                              onClick={props.closeModal}
                            >
                              {element.linkTitle}
                            </a>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="quickfilter-wrapper-buttons-mbl">
          <div className="quickfilter-row-mbl button-bottom-padding">
            <div className="quickfilter-col-16-button-mbl">
              <div className="quickfilter-row-button-mbl">
                <div className="quickfilter-col-button-mbl search-button">
                  <button
                    type="button"
                    onClick={() => {
                      handleSearchMobile();
                    }}
                    id={
                      jsonData.quickFilterContainer.quickFilter
                        .searchButtonLabel
                    }
                    className="quick-filter-search primary_btn"
                  >
                    {
                      jsonData.quickFilterContainer.quickFilter
                        .searchButtonLabel
                    }
                  </button>
                </div>
                <div className="quickfilter-col-button-mbl cancel-button">
                  <button
                    type="button"
                    onClick={() => {
                      props.setToggle();
                      handleCancel();
                    }}
                    className="quick-filter-cancel secondary_btn"
                  >
                    {localization.cancel}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

export default QuickFilter;
